import { render, staticRenderFns } from "./quick-login-reg.vue?vue&type=template&id=b281505c"
import script from "./quick-login-reg.vue?vue&type=script&lang=js"
export * from "./quick-login-reg.vue?vue&type=script&lang=js"
import style0 from "./quick-login-reg.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/quick-login-reg/quick-login-reg.vue
// module id = 6kpP
// module chunks = 0